import {Department} from "@/models/Department";

const departments:Array<Department> = [];

const state = {
  isLoading: false,
  isSaving: false,
  departments,
  selectedDepartment: new Department,
  modalFormVisible: false
};

export default state;
export type State = typeof state;
